import React from 'react';
import { XCircle, PenTool } from 'lucide-react';
import Select from 'react-select';

const AIRewriterModal = ({ 
  show, 
  onClose, 
  filteredData, 
  rewriteOption, 
  setRewriteOption, 
  selectedRowNumbers, 
  setSelectedRowNumbers, 
  onRewrite 
}) => {
  if (!show) return null;

  // Create options for the row selector with simplified labels
  const rowOptions = filteredData.map((row, index) => ({
    value: index + 1,
    label: `${index + 1}: ${row['Touchpoints'] || 'No touchpoint'}`  // Removed "Row" prefix
  }));

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 w-[800px]">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">AI Touchpoint Rewriter</h2>
          <button
            onClick={() => {
              onClose();
              setSelectedRowNumbers([]);
            }}
            className="text-gray-500 hover:text-gray-700"
          >
            <XCircle size={20} />
          </button>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Select rows to rewrite
          </label>
          <select
            value={rewriteOption}
            onChange={(e) => {
              setRewriteOption(e.target.value);
              setSelectedRowNumbers([]); // Reset selections when changing option
            }}
            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
          >
            <option>Custom Rows</option>
            <option>All Rows</option>
            <option>Rows with Empty AI Rewritten Text</option>
          </select>

          {rewriteOption === 'Custom Rows' && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Select rows to rewrite
              </label>
              <Select
                isMulti
                options={rowOptions}
                value={rowOptions.filter(option => 
                  selectedRowNumbers.includes(option.value)
                )}
                onChange={(selected) => {
                  setSelectedRowNumbers(
                    selected ? selected.map(option => option.value) : []
                  );
                }}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Select rows to rewrite..."
                noOptionsMessage={() => "No rows available"}
                maxMenuHeight={200}
              />
              <p className="mt-1 text-sm text-gray-500">
                Select one or more rows to rewrite their touchpoints
              </p>
            </div>
          )}
        </div>

        <div className="flex justify-end space-x-3">
          <button
            onClick={() => {
              onClose();
              setSelectedRowNumbers([]); // Reset on cancel
            }}
            className="px-4 py-2 text-gray-600 hover:text-gray-800 font-medium"
          >
            Cancel
          </button>
          <button
            onClick={onRewrite}
            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 font-medium flex items-center gap-2"
          >
            <PenTool size={16} />
            Rewrite Selected Rows
          </button>
        </div>
      </div>
    </div>
  );
};

export default AIRewriterModal;